module.exports = __webpack_public_path__ + "img/696969_A0A0A0_949494_8C8C8C-256px.57caf6aa.png";